// How the sign-in editor's forms read the settings document: a list as one entry per line, a
// missing string as "". Pure.
import type { Json } from "../../settings/inherit";

/** The non-blank lines of a textarea, trimmed. */
export function lines(text: string): string[] {
  return text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter((line) => line !== "");
}

export function text(value: Json | undefined): string {
  return typeof value === "string" ? value : "";
}

/** A list of strings, one per line. */
export function strings(value: Json | undefined): string {
  return Array.isArray(value) ? value.filter((v): v is string => typeof v === "string").join("\n") : "";
}

export function nullIfBlank(value: string): string | null {
  const trimmed = value.trim();
  return trimmed === "" ? null : trimmed;
}

/** The settings schema's httpsUrl: https, a host, an optional port and path, no query or fragment. */
export const HTTPS_URL = /^https:\/\/[A-Za-z0-9.-]{1,253}(:[0-9]{1,5})?(\/[A-Za-z0-9._~%!$&'()*+,;=:@/-]*)?$/;
